import moment from "moment-timezone";
import { v4 as uuidv4 } from "uuid";

const REVIEW_UUID_KEY = "usr-brt-uuid";

export function getOrCreateReviewUUID() {
  try {
    let userData = JSON.parse(localStorage.getItem(REVIEW_UUID_KEY));
    if (userData === null) {
      const uuid = uuidv4();
      userData = {
        uuid,
        timestamp: moment().tz("America/Toronto").format("YYYY-MM-DD HH:mm:ss"),
        expires: moment()
          .tz("America/Toronto")
          .add(1, "day")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
      localStorage.setItem(REVIEW_UUID_KEY, JSON.stringify(userData));
    }
    return userData;
  } catch (error) {
    const uuid = uuidv4();
    const userData = {
      uuid,
      timestamp: moment().tz("America/Toronto").format("YYYY-MM-DD HH:mm:ss"),
      expires: moment()
        .tz("America/Toronto")
        .add(1, "day")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
    localStorage.setItem(REVIEW_UUID_KEY, JSON.stringify(userData));
    return userData;
  }
}
